export const habaProduct = {
  habaProductCard: {
    newTag: 'Neu im Shop',
    sustainableTag: 'Nachhaltig',
    bestsellerTag: 'Bestseller',
    saleTag: 'Sale',
    color: 'Farben',
    from: 'ab',
    configurable: 'konfigurierbar',
    configurableDetails:
      'Dieses Produkt ist konfigurierbar, wodurch sich der tatsächliche Preis verändern kann.',
    priceListTextDesktop: '<b>Listenpreis</b>',
    priceListTextMobile: '<b>Listenpreis.</b>',
    chooseSize: 'Größe wählen',
    aiImageAlt: 'KI-generiertes Bild',
  },
  habaProductDetails: {
    notificationSubscribeTitle: 'Benachrichtigung per E-Mail aktiviert',
    notificationSubscribeBody: 'Sie werden informiert, sobald das Produkt wieder verfügbar ist',
    additionalInformation: 'Mehr Informationen (PDF-Download)',
    deliveryDetails: 'Details zur Lieferung',
    addToCart: 'In den Warenkorb',
    addToCartShort: 'Hinzufügen',
    addToCartFinished: 'Hinzugefügt',
    disabled: 'Zur Zeit nicht bestellbar',
    openConfigurator: 'Jetzt konfigurieren',
    openConfiguratorFromProductCard: 'Konfigurieren',
    from: 'ab',
    downloadCertificate: 'Zertifikat herunterladen:',
    quantity: 'Menge',
    descriptionMoreLink: 'Mehr erfahren',
    descriptionHeadline: 'Produktbeschreibung',
    productLine: {
      warrantyUnit: 'Jahre',
      warrantyCaption: 'Garantie',
      moreLink: 'Mehr erfahren',
      comfort: {
        headline: 'Unsere Comfort Linie',
        badge: 'Comfort',
        warrantyYears: '5',
        moreLinkUrl: '/inspiration-wissen/produktwelten/professional-und-comfort#wehrfritz-comfort',
        description:
          'Die <b>Sortimentslinie Wehrfritz Comfort</b> überzeugt mit einem attraktiven Preis-Leistungs-Verhältnis, das Qualität und Funktionalität harmonisch vereint.',
      },
      professional: {
        headline: 'Unsere Professional Linie',
        badge: 'Professional',
        warrantyYears: '10',
        moreLinkUrl:
          '/inspiration-wissen/produktwelten/professional-und-comfort#wehrfritz-professional',
        description:
          'Die <b>Sortimentslinie Wehrfritz Professional</b> steht für höchste Qualität, Funktionalität und eine Vielfalt, die keine Wünsche offenlässt. Mit zertifizierten Sicherheitsstandards, langlebigen Materialien und einer bis zu 10-jährigen Garantie setzt diese Linie Maßstäbe.',
      },
    },
    vat: 'inkl. MwSt.',
    taxDelivery: 'zzgl. Versand- bzw. Frachtkosten',
    plus: 'zzgl.',
    isNoMoreFixedBookPrice: 'Frühere Buchpreisbindung aufgehoben',
    deliveryCosts: 'Versandkosten',
    freightCosts: 'Frachtkosten',
    outOfStock: 'Nicht mehr verfügbar',
    instructions: 'Material & Pflegehinweise',
    pdfDownloads: 'Mehr Informationen (Download)',
    certificates: 'Zertifikate / Siegel',
    energyLabelLinkText: 'Produktdatenblatt',
    listPriceMessage: '<strong>Listenpreis</strong>',
    listPriceLoggedInMessage: '<strong>Listenpreis</strong>',
    strikethroughPriceMessage: '<strong>Aktionspreis</strong>',
    strikethroughPriceMessageEndOfLife: '<strong>Abverkaufspreis</strong>',
    listPrice: '<strong>Listenpreis</strong>',
    customerSpecificPriceMessage: '<strong>Ihr Preis,</strong> inkl.',
    customerSpecificPriceMessageShort: '<strong>Ihr Preis</strong>',
    reduction: 'Rabatt',
    classifications: {
      qs: {
        headline: 'Hinweise',
        sub: {
          h_saetze: 'H-Sätze',
          ghssymbolundsignalwort: 'GHS-Symbol und Signalwort',
          warnhinweise: 'Hinweise',
        },
      },
      stoffartikel: {
        headline: 'Material & Pflegehinweise',
      },
      moebelartikel: {
        headline: 'Bestellhinweise',
      },
    },
    note: 'Hinweise',
    information: {
      moreInformation: {
        headline: 'Mehr Informationen',
      },
      certifactes: {
        headline: 'Zertifikate',
        label: 'Zertifikat herunterladen',
      },
      qaWarnings: {
        headline: 'Hinweise',
      },
      qaGHS: {
        headline: 'GHS-Symbol und Signalwort',
      },
      qaSafety: {
        headline: 'Sicherheitshinweise',
      },
      qaCare: {
        headline: 'Material- & Pflegehinweise',
      },
      qaHSentence: {
        headline: 'H-Sätze',
      },
    },
    certificate: {
      certifiedBy: 'Zertifiziert durch',
      licenceNumber: 'Lizenznummer',
    },
    manufacturer: 'Hersteller',
    pleaseSelectAmount: 'Bitte wählen Sie einen Betrag aus:',
    selectIndividualAmount: 'Oder wählen Sie einen individuellen Betrag:',
    amountInfo: 'Nur Beträge ohne Nachkommastellen zulässig.',
    enterAmount: 'Betrag eingeben',
    amountConfirm: 'Bestätigen',
    selectedVoucherValue: 'Ausgewählter Gutscheinwert',
    voucherValueAdjustedTitleSuccess: 'Der Gutscheinwert wurde angepasst',
    voucherValueAdjustedMessageSuccess: 'Jetzt müssen Sie ihn nur noch in den Warenkorb legen',
    voucherValueAdjustedTitleError: 'Ungültige Eingabe',
    voucherValueAdjustedMessageError:
      'Der Geschenkgutscheinwert muss ein gültiges Format ohne Dezimalstellen haben',
    voucherIntervalValueAdjustedMessageError:
      'Der gewählte Wert des Geschenkgutscheins muss zwischen 10 € und 500€ sein',
    freeDelivery: 'kostenloser Versand',
    configurable: 'Lieferbar in 7-8 Wochen',
    voucherReceiptInfo:
      '(der Erhalt kann einige Minuten dauern. Bitte prüfen Sie ggf. auch den Spam-Ordner)',
    selectVoucherValue: 'Wert wählen',
    minimumPrice: {
      bestPrice: '30-Tage-Bestpreis:',
      learnMore: 'Mehr erfahren',
      currentPriceIsTheLowestPrice:
        'Der „30-Tage-Bestpreis“ ist der niedrigste Preis, zu dem der Händler dieses Produkt in den 30 Tagen vor der letzten Preisänderung angeboten hat.',
      currentPriceIsNotTheLowestPrice:
        'Beim „30-Tage-Bestpreis“ handelt es sich um den niedrigsten Preis, zu dem der Händler dieses Produkt in den 30 Tagen vor der letzten Preisänderung angeboten hat. Aufrund vergangener Rabattaktionen kann der „30-Tage-Bestpreis“ niedriger ausfallen als der aktuelle Preis.',
      understood: 'Ich habe verstanden',
      modalTitle: 'Warum wird mir „Niedrigster Preis der letzten 30 Tage“ angezeigt?',
      modalParagraph1:
        'Aufgrund neuer EU-Gesetzgebung haben wir „Niedrigster Preis in den letzten 30 Tagen“ hinzugefügt. Dies hilft sowohl uns als auch unseren Kunden, rechtzeitig transparenter über Produktpreisänderungen zu informieren.<br><br>Beispielsweise betrug der niedrigste Preis des Produkts in den letzten 30 Tagen vor Beginn der neuen Verkaufskampagne (z. B. „Winterschlussverkauf“) 100,00 EUR. Dieser Preis wird als „Niedrigster Preis der letzten 30 Tage“ aufgeführt, wenn wir die erste Preissenkung (z. B. 90,00 EUR) in der neu gestarteten Kampagne ankündigen. Der „Niedrigste Preis der letzten 30 Tage“ bleibt während der gesamten Aktion gleich, auch wenn es innerhalb der gleichen Aktion zu weiteren Preissenkungen kommt (z. B. 80,00 EUR, 70,00 EUR usw.).',
      modalTitle2: 'Warum wird mir „Niedrigster Preis der letzten 30 Tage“ angezeigt?',
      modalParagraph2:
        'Gemäß der neuen EU-Preisauszeichnungsverordnung wird bei jeder kommunizierten Werbeaktion der von uns angewandte sogenannte „bisherige Preis“ angegeben. Was der Gesetzgeber als „vorheriger Preis“ bezeichnet, nennen wir „Niedrigster Preis der letzten 30 Tage“.',
      euLegislationLinkTitle:
        'Weitere Informationen zur neuen EU-Gesetzgebung zur Preisauszeichnung finden Sie auf dieser Website.',
      euLegislationLink:
        'https://commission.europa.eu/law/law-topic/consumer-protection-law/unfair-commercial-practices-and-price-indication/price-indication-directive_en',
    },
    availability: {
      green: 'Auf Lager',
      yellow: 'Nachschub ist unterwegs',
      red: 'Ausverkauft',
      configurable: 'Fertigung nach Bestellung',
      procureOnOrder: 'Beschaffung nach Bestellung',
    },
  },
  habaProductConfigurator: {
    messages: {
      success: 'Dein Artikel wurde zum Warenkorb hinzugefügt',
      error: 'Dein Artikel konnte nicht in den Warenkorb gelegt werden',
    },
    isLoading: 'Das Produkt wird in den Warenkorb gelegt. Bitte haben Sie einen Moment Geduld.',
    delivery: 'Lieferbar in 9 - 11 Wochen',
    cancelHint: 'Konfiguration abbrechen',
  },
  habaProductVariants: {
    color: 'Farbe',
    size: 'Größe',
    sold: 'Ausverkauft',
  },
  habaProductConsultant: {
    product: 'Produkt',
    description: 'Beschreibung',
    price: 'Preis',
    actions: 'Aktion',
    suggestions: 'Produktvorschläge',
    totalPriceText: 'Gesamtpreis für komplette Ausstattung:',
  },
};
